import { useState, useEffect } from "react";
export type Headset = "Quest" | "Focus" | "Pico";

export function isValidHeadset(value: string): boolean {
  const validHeadsets: Headset[] = ["Quest", "Focus", "Pico"];
  return validHeadsets.includes(value as Headset);
}

interface UseSelectedHeadsetProps {
  setHeadsetFromUrl?: boolean;
}

export function useSelectedHeadset(props: UseSelectedHeadsetProps = {}) {
  const [selectedHeadset, _setSelectedHeadset] = useState<Headset>("Pico");
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isInitialized || props.setHeadsetFromUrl === false) return;
    // check URL params for headset type and set it if there is one
    const urlParams = new URLSearchParams(window.location.search);
    const headset = urlParams.get("headset");
    if (headset && isValidHeadset(headset)) {
      _setSelectedHeadset(headset as Headset);
      setIsInitialized(true);
    }
  }, [window.location.search]);

  const setSelectedHeadset = (headset: Headset) => {
    _setSelectedHeadset(headset);
    setIsInitialized(true);
    if (!headset) return;
    // update URL params with headset type
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("headset", headset);

    // Keep the URL fragment, I.e. #Calibration
    const fragment = window.location.hash;

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${urlParams}${fragment}`
    );
  };

  return {
    selectedHeadset,
    setSelectedHeadset,
    isHeadsetSelected: selectedHeadset !== undefined,
  };
}
